<template lang="pug">
.rich-text
  .blockquote
    p 赛博朋克2077不再是幻想，在这里邂逅未来，窥视想象，尽情畅游。
    p ALIPAY支付宝空间站即日起航，就等你了，快上车。
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-11597577930344.png")
  h2 微笑入口 Smile Entrance
  p 微笑就是独一无二的通行证，人脸激活，开启美好的Alipay Lab旅程
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-21597577930373.png")
  h2 阿里动物园 Ali Zoo
    p 用身体去感受，在Ali Zoo化身成阿里经济体动物形象，邂逅阿里森林伙伴
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-31597577930395.png")
  h2 飞越蚂蚁森林 Leap Ant Forest
  p 乘上魔幻驾座，跟随能量球，领略上海到阿拉善森林一路沿途的美景，见证荒漠变绿洲，真切感受线下蚂蚁森林
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-41597577930418.png")
  h2 DAMO 5G赛车漂移 DAMO 5G Racing Car
  p 所见即所得，体验5G网络的高速率低时延，虚拟趣味驾驶，带给你全新驾驶体验
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-51597577930441.png")
  h2 互动区 Interactive Zone
  p 肆意挥洒热情和汗水，在未来城市穿梭，与同伴进行能量球收集比拼，用最酷的姿势拥有最多的能量
  .figure
    img(src="https://antlab-mp.zjian.cc/imgs/upload/evt-9-1-61597577930465.png")
  h2 微笑商店Smile Shop
  p 体验未来的购物畅想——选取心仪产品，轻松扫脸支付，全自动化取货流程，心仪产品直接送达
</template>
<script>
export default {
  name: 'RichText',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.rich-text
  width: 100%
  padding-bottom: pxToRem(100)
  .blockquote
    padding-left: pxToRem(20)
    border-left: #DDDDDD 3px solid
    margin-bottom: pxToRem(40)
    p
      font-size: 16px
      color: #999999
  h2
    font-size: 16px
    color: black
    margin-bottom: pxToRem(20)
  p
    font-size: 16px
    color: #999999
  .figure
    margin-top: pxToRem(40)
    width: 100%
    img
      width: 100%
</style>
